<template>
    <div class="row">
        <div class="col-md-6">
            <div class="card card-custom gutter-b">
                <div class="card-header">
                    <div class="card-title">
                        <h3 class="card-label">
                            Geschäft wählen
                            <small> und Bestandsliste hochladen</small>
                        </h3>
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-group mb-4">
                        <select
                            class="form-control form-control-sm"
                            id="company_select"
                            v-model="selectedStore"
                            @change="setStore"
                        >
                            <option value="0">bitte wählen...</option>
                            <option
                                v-for="store in stores"
                                :key="store.id"
                                :value="store.id"
                            >
                                {{ store.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card card-custom gutter-b">
                <div class="card-header">
                    <div class="card-title">
                        <h3 class="card-label">
                            Upload
                            <small>Bestandsliste</small>
                        </h3>
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-group mb-8" v-if="useFtp">
                        <div
                            class="alert alert-custom alert-default"
                            role="alert"
                        >
                            <div class="alert-icon">
                                <i class="fas fa-info text-primary"></i>
                            </div>
                            <div class="alert-text">
                                Sie haben einen automatischen Upload per FTP
                                konfiguriert. Bestandslisten werden somit
                                automatisch eingelesen.
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-4 row">
                        <label
                            class="col-6 col-form-label"
                            >Möchten Sie eine Bestandsliste manuell
                            hochladen?</label
                        >
                        <div class="col-6">
                            <span
                                class="switch switch-outline switch-icon switch-success"
                            >
                                <label>
                                    <input
                                        type="checkbox"
                                        name="manually_upload"
                                        v-model="manuallyUpload"
                                    />
                                    <span></span>
                                </label>
                            </span>
                        </div>
                    </div>
                    <vue-dropzone
                        v-if="manuallyUpload"
                        ref="fileUploader"
                        id="file_uploader"
                        :options="uploadOptions"
                        @vdropzone-complete="afterComplete"
                        @vdropzone-sending="addFormData"
                    >
                    </vue-dropzone>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
    name: "UploadStocks",

    components: {
        vueDropzone: vue2Dropzone
    },

    props: {
        connectors: {
            type: Array,
            default: () => []
        },
        stores: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            selectedStore: 0,
            manuallyUpload: false,
            useFtp: false,
            uploadOptions: {
                url: this.$route("stock-upload.store"),
                thumbnailWidth: 150,
                uploadMultiple: false,
                parallelUploads: 1,
                autoProcessQueue: true,
                addRemoveLinks: true,
                dictDefaultMessage:
                    "<i class='fa fa-upload'></i> Datei hier uploaden"
            }
        };
    },

    methods: {
        setStore() {
            if (this.selectedStore != 0) {
                for (let key in this.connectors) {
                    let connector = this.connectors[key];
                    if (connector.store_uuid == this.selectedStore) {
                        this.useFtp = connector.source === "ftp" ? true : false;
                    }
                }
            } else {
                this.useFtp = false;
            }
        },
        async afterComplete(response) {
            if (response.status == "success") {
                toastr.success("Bestandsliste wurde hochgeladen und wird nun verarbeitet.");
                this.$refs.fileUploader.removeAllFiles();
            } else {
                toastr.error("Fehler beim Upload der Datei");
                this.$refs.fileUploader.removeAllFiles();
            }
        },
        addFormData(file, xhr, formData) {
            formData.append("_token", this.$csrf_token());
            formData.append("store_uuid", this.selectedStore);
            formData.append("only_column_check", false);
        },
    },

    mounted() {
        if (this.stores.length == 1) {
            this.selectedStore = this.stores[0].id;
            this.useFtp = false;
            if (this.connectors) {
                this.useFtp = this.connectors[0].source === "ftp" ? true : false;
            }
        }
    }
};
</script>
